import SubPageHeader from '../SubPageHeader';
import { useState, useEffect } from 'react';
import SellGoLogo from '@/components/SellGoLogo';
import { api } from '@/api/apiClient';

export default function AppInfoSection({ onBack }) {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    api.get('/diagnostics/info')
      .then(res => { if (res?.success) setCompany(res.data); })
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-col min-h-full" dir="rtl">
      <SubPageHeader title="معلومات التطبيق" onBack={onBack} />
      <div className="p-4 space-y-4">

        {/* Brand card */}
        <div className="rounded-2xl p-5 flex flex-col items-center gap-3 text-white" style={{ background: 'linear-gradient(135deg, #1E3A5F 0%, #2563EB 100%)' }}>
          <SellGoLogo size={72} />
          <div className="text-center">
            <p className="font-black text-2xl tracking-tight">
              <span className="text-white">Sell</span>
              <span style={{ color: '#10B981' }}>Go</span>
            </p>
            <p className="text-white/70 text-sm mt-0.5">نظام مبيعات وتوزيع متكامل</p>
          </div>
        </div>

        {/* Version */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">📱 إصدار التطبيق</p>
          {[
            ['الإصدار', 'v2.1.0'],
            ['رقم البناء', '145'],
            ['آخر تحديث', '5 مايو 2026'],
            ['قناة التحديث', 'Stable'],
          ].map(([label, value]) => (
            <div key={label} className="flex justify-between items-center py-2.5 border-b border-border last:border-0">
              <span className="text-sm text-muted-foreground">{label}</span>
              <span className="text-sm font-semibold text-foreground">{value}</span>
            </div>
          ))}
        </div>

        {/* Developer */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">🏢 المطوّر</p>
          <div className="flex flex-col items-center gap-1 py-2 mb-2">
            <span className="text-xs text-muted-foreground">Powered by</span>
            <span className="font-black text-lg tracking-wider" style={{ color: '#D85A4A' }}>TECH SHARK</span>
            <span className="text-muted-foreground/60 text-xs tracking-widest">FOR TECHNOLOGY</span>
          </div>
          {[
            ['المطور', 'Tech Shark For Technology'],
            ['الدعم الفني', 'support@techshark.tech'],
          ].map(([label, value]) => (
            <div key={label} className="flex justify-between items-center py-2.5 border-t border-border">
              <span className="text-sm text-muted-foreground">{label}</span>
              <span className="text-sm font-semibold text-foreground">{value}</span>
            </div>
          ))}
        </div>

        {/* Technical (admin) */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">⚙️ تفاصيل تقنية</p>
          {[
            ['الإطار', 'React + Vite'],
            ['الخلفية', 'Odoo 17 Community'],
            ['البروتوكول', 'REST / JSON'],
            ['قاعدة البيانات', 'PostgreSQL'],
            ['إصدار Odoo', company?.odoo_version || 'جاري التحميل...'],
            ['اللغة', 'العربية (RTL)'],
          ].map(([label, value]) => (
            <div key={label} className="flex justify-between items-center py-2.5 border-b border-border last:border-0">
              <span className="text-sm text-muted-foreground">{label}</span>
              <span className="text-sm font-semibold text-foreground">{value}</span>
            </div>
          ))}
        </div>

        {/* Company from Odoo */}
        {company && (
          <div className="bg-card border border-border rounded-2xl p-4">
            <p className="font-bold text-sm text-foreground mb-3">🏢 الشركة</p>
            <div className="flex justify-between items-center py-2.5 border-b border-border">
              <span className="text-sm text-muted-foreground">الشركة</span>
              <span className="text-sm font-semibold text-foreground">{company.company || '—'}</span>
            </div>
            <div className="flex justify-between items-center py-2.5">
              <span className="text-sm text-muted-foreground">قاعدة البيانات</span>
              <span className="text-sm font-semibold text-foreground" dir="ltr">{company.db || '—'}</span>
            </div>
          </div>
        )}

        {/* Legal */}
        <div className="text-center space-y-1 py-2">
          <p className="text-xs text-muted-foreground">حقوق النشر © 2026 — جميع الحقوق محفوظة</p>
          <p className="text-xs" style={{ color: '#D85A4A', fontWeight: 700 }}>TECH SHARK FOR TECHNOLOGY</p>
        </div>

      </div>
    </div>
  );
}